<template>
  <div class="accountSet">
    <a-spin :spinning="spinning" size="large">
      <div class="accout_head">
        <p>人员管理</p>
        <div class="head_box">
          <img src="@/assets/fill.png" alt="">
          <span class="role">各角色权限与职责说明（必读）</span>
          <a href="https://www.yuque.com/docs/share/5206fe7e-e56a-41c2-8804-a5b5703727d2?# 《绿萝中的角色与权限设置》" target="_black">点击查看</a>
        </div>
      </div>
      <div v-if="accoutInfo" class="countTotal">
        <ul>
          <li v-for="(item, index) in countInfo" :key="index + 'cou'">
            <span style="color: #8C8C8C;">{{item.title}}</span>
            <span class="count_num">{{typeNum[index]}}</span>
            <span v-if="item.subtitle" style="color: #1890FF; cursor: pointer;" @click="setHandle(index)">{{item.subtitle}}</span>
          </li>
        </ul>
      </div>
      <div class="countList">
        <div class="list_top">
          <h3 style="font-size: 14px; font-weight: bold;">账号管理列表</h3>
        </div>
        <div class="list_foot" v-if="accoutInfo">
          <div class="options">
            <div>
              <a-input placeholder="姓名" v-model="teacherName" />
              <a-select class="option" placeholder="筛选年级" style="width: 120px" @change="handleChangeGrade" allowClear>
              <a-select-option v-for="(item, index) in gradeList" :key="index" :value="item.value">{{item.label}}</a-select-option>
              </a-select>
              <a-select class="option" v-model="classValue" placeholder="筛选班级" @change="handleChangeClass" style="width: 120px" allowClear>
                <a-select-option v-for="(item, index) in classList" :key="index" :value="item.value">{{item.label}}</a-select-option>
              </a-select>
              <a-button class="commit" type="primary" @click="searchHandle">查询</a-button>
            </div>
            <div>
              <a-button @click="resetHandle" type="primary" style="margin-right: 10px">批量重置密码</a-button>
              <a-button @click="removeHandle">批量删除</a-button>
            </div>
          </div>
          <a-table :columns="columns" :data-source="accoutInfo" :row-key="row => row.USERS_NAME" :row-selection="rowSelection" :pagination="{ pageSize: 6 }">
            <template slot="CLASS_LIST" slot-scope="text, record">
              <span v-if="!record.CLASS_LIST || !record.CLASS_LIST.length">--</span>
              <div v-else>
                <span>{{grade(record.CLASS_LIST[0].GRADE_ID)}}{{record.CLASS_LIST[0].CLASS_ID}}班
                  <a-popover placement="top" v-if="record.CLASS_LIST && record.CLASS_LIST.length > 1">
                    <template slot="content">
                      <ul style="padding-left: 0px">
                        <li v-for="(list, index) in record.CLASS_LIST" :key="index + 1">{{grade(list.GRADE_ID)}}{{list.CLASS_ID}}班</li>
                      </ul>
                    </template>
                    <a-button type="link">【查看全部】</a-button>
                  </a-popover>
                </span>
              </div>
              <!-- <a-popover v-else>
                <template slot="content">
                  <ul style="padding-left: 0px">
                    <li v-for="(list, index) in record.CLASS_LIST" :key="index + 1">{{grade(list.GRADE_ID)}}{{list.CLASS_ID}}班</li>
                  </ul>
                </template>
                <a-icon type="eye" theme="filled" />
              </a-popover> -->
            </template>
            <template slot="ROLE_ID" slot-scope="text">{{ text === 1 ? '超级管理员' : (text === 2 ? '管理员' : (text === 3 ? '班主任' : (text === 4 ? '非班主任' : '未知' ))) }}</template>
            <template slot="PHONENUMBER" slot-scope="text">{{text ? text : '暂无'}}</template>
          </a-table>
        </div>
      </div>
      <invite-link v-show="copyStatus" :info="inviteInfo"></invite-link>
    </a-spin>
  </div>
</template>

<script>
  import { mapState, mapActions, mapMutations } from 'vuex'
  import InviteLink from './InviteLink'
  import GradeNum from '@/util/gradeNum'

  export default {
    name: 'AccountSet',
    components: {
      InviteLink
    },
    data () {
      return {
        countInfo: [{title: '当前学校账号总数'}, {title: '管理员账号', subtitle: '添加管理员'}, {title: '班主任账号', subtitle: '邀请班主任'}, {title: '非班主任账号', subtitle: '邀请非班主任'}],
        columns: [
          {
            title: '账号（身份证）',
            dataIndex: 'USERS_NAME',
            key: 'USERS_NAME'
          },
          {
            title: '姓名',
            dataIndex: 'FULL_NAME',
            key: 'FULL_NAME'
          },
          {
            title: '绑定班级',
            dataIndex: 'CLASS_LIST',
            key: 'CLASS_LIST',
            scopedSlots: { customRender: 'CLASS_LIST' }
          },
          {
            title: '角色',
            dataIndex: 'ROLE_ID',
            key: 'ROLE_ID',
            scopedSlots: { customRender: 'ROLE_ID' }
          },
          {
            title: '联系方式',
            dataIndex: 'PHONENUMBER',
            key: 'PHONENUMBER',
            scopedSlots: { customRender: 'PHONENUMBER' }
          }
        ],
        rowSelection: {
          onChange: (selectedRowKeys, selectedRows) => {
            console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
          },
          onSelect: (record, selected, selectedRows) => {
            this.selectedList = selectedRows
            console.log(this.selectedList)
            console.log(record, selected, selectedRows);
          },
          onSelectAll: (selected, selectedRows, changeRows) => {
            this.selectedList = selectedRows
            console.log(selectedRows)
            console.log(selected, selectedRows, changeRows);
          }
        },
        inviteInfo: null,
        accoutInfo: null,
        typeNum: null,
        selectedList: null,
        spinning: true,
        gradeList: [],
        classList: [],
        teacherName: null,
        classValue: undefined,
        gradeID: null,
        classID: null
      }
    },
    computed: {
      ...mapState([
        'copyStatus',
        'totalAccout',
        'isDeleteUser',
        'resetInfo'
      ])
    },
    watch: {
      totalAccout () {
        const grade = []
        this.accoutInfo = this.totalAccout.filter(item => (item.ROLE_ID !== 1 && item.ROLE_ID !== 0))
        this.typeNum = [this.accoutInfo.length, this.totalAccout.filter(item => item.ROLE_ID === 2).length, this.totalAccout.filter(item => item.ROLE_ID === 3).length, this.totalAccout.filter(item => item.ROLE_ID === 4).length]
        this.accoutInfo.map(value => {
          if (value.CLASS_LIST) {
            value.CLASS_LIST.map(list => {
              if (!grade.includes(list.GRADE_ID)) {
                grade.push(list.GRADE_ID)
                this.gradeList.push({
                  label: GradeNum(list.GRADE_ID),
                  value: list.GRADE_ID,
                  classList: [{
                    label: list.CLASS_ID + '班',
                    value: list.CLASS_ID
                  }]
                })
              } else {
                this.gradeList.find(item => {
                  if (item.value === list.GRADE_ID) {
                    item.classList.push({
                      label: list.CLASS_ID + '班',
                      value: list.CLASS_ID
                    })
                  }
                })
              }
            })
          }
        })
        this.gradeList.sort((a, b) => a.value - b.value)
      }
    },
    async mounted () {
      setTimeout(() => {
        this.spinning = false
      }, 1000)
      await this.getTotalAccout()
    },
    methods: {
      ...mapActions([
        'getTotalAccout',
        'deleteUserAccount',
        'resetPassword',
        'logAdd'
      ]),
      ...mapMutations([
        'setCopyStatus'
      ]),
      grade (grade) {
        return GradeNum(grade)
      },
      addHandle(){
        this.$router.push('/userList/AddUserAccount')
      },
      setHandle (ind) {
        if (ind === 1) {
          this.$router.push('/userList/addmanage')
        } else if (ind === 2) {
          this.inviteInfo = '班主任'
          this.setCopyStatus(true)
        } else {
          this.inviteInfo = '非班主任'
          this.setCopyStatus(true)
        }
      },
      async resetHandle () {
        if (!this.selectedList || !this.selectedList.length) {
          this.$warning({
            title: '提示',
            content: '请先选择要重置密码的账号！',
          })
        } else {
          let result = []
          this.selectedList.map(item =>{
            let info = {
              userName : item.USERS_NAME
            }
            result.push(info)
          })
          await this.resetPassword(result)
          if (this.resetInfo) {
            await this.logAdd({
              name: '我的-人员管理-批量重置密码',
              remarks: `成功重置${result.length}个账号`
            })
            this.$message.success('重置密码成功')
          } else {
            this.$message.error('重置密码失败')
          }
        }
      },
      removeHandle () {
        if (!this.selectedList || !this.selectedList.length) {
          this.$warning({
            title: '提示',
            content: '请先选择要删除的账号！',
          })
        } else {
          this.$confirm({
            title: '删除教师信息后不可恢复',
            content: '你还要继续吗',
            okText: '确定',
            okType: 'danger',
            cancelText: '取消',
            onOk: async() => {
              let result = []
              this.selectedList.map(item =>{
                let info = {
                  userName : item.USERS_NAME,
                  status : 2
                }
                result.push(info)
              })
              console.log(result)
              await this.deleteUserAccount(result)
              if (this.isDeleteUser) {
                this.$message.success('删除成功')
                await this.getTotalAccout()
              } else {
                this.$message.error('删除失败')
              }
            },
            onCancel() {}
          })
        }
      },
      handleChangeGrade (value) { // 年级筛查（每次更新同步班级）
        this.classValue = undefined
        this.classList = []
        this.classID = null
        this.gradeID = value
        this.gradeList.map(item => {
          if (item.value === value) {
            this.classList = item.classList
          }
        })
      },
      handleChangeClass (value) { // 班级筛查
        this.classID = value
      },
      searchHandle () { // 查询教师
        this.accoutInfo = this.totalAccout
        .filter((item) => !this.teacherName ? true : item.FULL_NAME.indexOf(this.teacherName) !== -1)
        .filter((item) => {
          if (!this.gradeID) {
            return item
          } else {
            if (item.CLASS_LIST) {
              let newItem = null
              item.CLASS_LIST.forEach(list => {
                if (list.GRADE_ID === this.gradeID) {
                  if (!this.classID) { // 年级
                    newItem = item
                  } else {
                    if (list.CLASS_ID === this.classID) { // 年级班级
                      newItem = item
                    }
                  }
                }
              })
              return newItem
            }
          }
        })
        .filter(item => (item.ROLE_ID !== 1 && item.ROLE_ID !== 0))
      }
    }
  }
</script>

<style>
.accountSet {
  width: 100%;
  font-size: 14px;
  color: #262626;
}
.accountSet .list_foot .ant-table-tbody .ant-btn {
  padding: 0px!important;
  border-width: 0px!important;
}
.accountSet .list_foot .ant-table-tbody .ant-btn:hover, .accountSet .list_foot .ant-table-tbody .ant-btn:focus {
  color: #40a9ff;
  border-width: 0px!important;
}
.accountSet .accout_head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 24px;
}
.accountSet .accout_head img {
  width: 14px;
  height: auto;
}
.accountSet .accout_head p {
  font-size:24px;
  font-weight:500;
  color:rgba(38,38,38,1);
  margin: 0px;
}
.accountSet .accout_head .head_box {
  padding: 9px 17px;
  border-radius: 4px;
  border: 1px solid #FAE2B1;
  background-color: #F9F1E2;
  box-sizing: border-box;
}
.accountSet .accout_head .head_box .role {
  display: inline-block;
  margin: 0px 16px;
}
.accountSet .accout_head .head_box a {
  text-decoration: underline;
}
.accountSet .countTotal > ul {
  margin: 0px;
  padding: 0px;
  display: flex;
  border: 1px solid #E8E8E8;
  background-color: #FFFFFF;
}
.accountSet .countTotal > ul li {
  flex-basis: 25%;
  padding: 32px 0px;
  box-sizing: border-box;
  text-align: center;
}
.accountSet .countTotal > ul li:first-child {
  padding: 43px 0px;
  border-right: 1px solid #E8E8E8;
}
.accountSet .countTotal > ul li span {
  display: block;
}
.accountSet .countTotal > ul li .count_num {
  margin: 10px 0px 24px;
  font-size: 24px;
}
.accountSet .countTotal > ul li:first-child .count_num {
  margin: 16px 0px 0px;
  font-size: 32px;
}
.accountSet .countList {
  margin: 18px 0px 60px;
  border: 1px solid #E8E8E8;
  background-color: #FFFFFF;
}
.accountSet .countList .list_top {
  padding: 16px 24px;
  box-sizing: border-box;
  border-bottom: 1px solid #E8E8E8;
}
.accountSet .countList .ant-table-pagination.ant-pagination {
  margin: 16px 24px 16px 0px;
}
.accountSet .countList .ant-table-thead > tr > th, .accountSet .countList .ant-table-tbody > tr > td {
  padding: 16px 24px;
}
.accountSet .countList .ant-btn-primary, .ant-modal-confirm .ant-btn-primary {
  background-color: #51BF94;
}
.accountSet .countList .ant-btn-primary:hover, .ant-modal-confirm .ant-btn-primary:hover, .accountSet .countList .ant-btn-primary:focus, .ant-modal-confirm .ant-btn-primary:focus, .ant-btn-danger:hover {
  color: #FFFFFF;
  background-color:rgba(81, 191, 148, .7);
}
.accountSet .countList .ant-pagination-item-active, .accountSet .countList .ant-pagination-item-active:focus, .accountSet .countList .ant-pagination-item-active:hover {
  border-color: #51BF94;
}
.ant-btn-danger {
  color: #FFFFFF!important;
  border-color: #51BF94!important;
  background-color: #51BF94!important;
}
.accountSet input{
  width: 120px;
  height: 32px;
  margin-right: 14px;
}
.accountSet .options {
  padding: 16px 24px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
}
.accountSet .options > div > div {
  margin-right: 10px;

}
</style>
